import Icon from '../components/Icon.vue'

Icon.register({
  'blender-phone': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M392 64c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h157.8l-17.5 64h-140.4c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h131.6l-17.5 64h-114.2c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h105.5l-17.5 64h-288v-352h384l-17.5 64h-166.5zM158.8 335c3 7.4 0.2 15.9-6.7 20.1l-39.4 24.2c-12.5 7.7-31.8 6-41.7-4.8-94.1-102.9-94.7-258.9-2.1-362.5 11.1-12.5 29.6-15.8 43.9-7l39.3 24.1c6.9 4.2 9.7 12.7 6.7 20.1l-25.8 63.3c-2.8 6.8-9.8 11-17.2 10.3l-45-4.4c-17.7 47.9-17.3 100.8 0 147.7l45-4.4c7.4-0.7 14.5 3.5 17.2 10.3zM480 384c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32h-352c-17.7 0-32-14.3-32-32v-32c0-35.3 28.7-64 64-64h288zM336 480c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/blender-phone.js
// module id = 665
// module chunks = 0